import React, { Component, useEffect, useState, useRef } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const ListLeaves = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	
	const [docfile,setDocFile]=useState(null);
	const [isImporting,setIsImporting]=useState(false);
	// Ref, not state: it updates synchronously, so back-to-back clicks in the
	// same tick see the flag. `isImporting` alone is a render behind and lets them through.
	const isSubmitting = useRef(false);
	const [isAssigning,setIsAssigning]=useState(false);
	
		const handleDocumentChange = (event) => {
			
			const file = event.target.files[0];
			if (file) {
				setDocFile(file);
			//   setPreview(URL.createObjectURL(file)); // Preview image
			}
		  };

	const [user, setUser] = useState({
		start_date: "",
		end_date: "",
	})

	const handelInput = (event) => {
		event.preventDefault();
		const { name, value } = event.target;
		console.log(name, value)
		setUser({ ...user, [name]: value });
	}



	const [url_name, setUrlname] = useState('');
	const [url_id, setUrlid] = useState('');
	const [url_link, setUrllink] = useState('');
	const [parent, setParent] = useState('');
	const history = useHistory();
	const [data, setData] = useState([]);
	const [datacount, setDataCount] = useState([]);
	const [dataval, setdataval] = useState([]);
	const [currentPageId, setCurrentPageId] = useState(1);


	// const [anand, setAnand]= useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);

	const { sortConfig, sortData, handleSort } = useSortData();

	const weekoffColumns = [
		{ label: "Department", key: "department_name", sortable: true },
		{ label: "Employee", key: "emp_info", sortable: true },
		{ label: "Shift Code", key: "shift_code", sortable: true },
		{ label: "Shift Name", key: "shift_name", sortable: true },
		{ label: "Day", key: "shift_date", sortable: true },
		{ label: "Timing", key: "day", sortable: true },
	];

	const safe = (val) => String(val ?? "").toLowerCase();
	let filteredItems = data.filter((item) =>
		`${safe(item.department_name)}${safe(item.emp_info)}${safe(item.shift_code)}`.includes(searchTerm.toLowerCase())
	);

	const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
	const indexOfLastItem = currentPage * itemsPerPage;
	const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	const sortedItems = sortData(filteredItems);
	const filteredData = sortedItems.slice(indexOfFirstItem, indexOfLastItem);
	const startIndex = (currentPage - 1) * itemsPerPage;

	useEffect(() => {
		setCurrentPage(1);
	}, [searchTerm]);

	const paginate = (pageNumber) => setCurrentPage(pageNumber);

	const handleSearch = (event) => {
		setSearchTerm(event.target.value);
	};


	const clearInput = () => {
		setSearchTerm("");
	  };


	const handleRowsPerPageChange = (e) => {
		setItemsPerPage(Number(e.target.value));
		setCurrentPage(1); // Reset to first page
	};



	

	useEffect(() => {
		axios.get(API_BASE_URL + '/weekoff_exceed_list', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then(res => setData(res.data))
			//  .then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])






	var elements = [];
	for (var i = 1; i <= datacount.total_page; i++) {
		elements.push(i);
	}

	//   for(var i=1;i<=datacount.total_page;i++){
	// 	elements.push(<li className="page-item"><a className="page-link" href="" onClick={() => handlePagination(i)}>
	// 	  {i}
	//   </a></li>);
	// }

	//console.log(elements)

	//   const [currentPage,setCurrentPage]= useState(1);
	const recordsPerPage = 10;

	const lastIndex = currentPage * recordsPerPage;
	const firstIndex = lastIndex - recordsPerPage;
	const records = data.slice(firstIndex, lastIndex);
	const npage = Math.ceil(data.length / recordsPerPage);
	const numbers = [...Array(npage + 1).keys()].slice(1);





	const handleDutyRosterSubmit = (e) => {

		e.preventDefault();

		if (isSubmitting.current) {
			return;
		}

		if (!docfile) {
			toast.error("Please choose a file to import.", {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",

			});
			return;
		}

		isSubmitting.current = true;
		setIsImporting(true);



		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/importdutyhost', {duty_host_file:docfile}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}`,'Content-Type': 'multipart/form-data' },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}

			if (status != 200) {
				isSubmitting.current = false;
				setIsImporting(false);
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);

			isSubmitting.current = false;
			setIsImporting(false);

			toast.error(error?.response?.data?.message || "Failed to import the duty roster file.", {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  // Fetch options from Laravel API
  useEffect(() => {
    axios.get(API_BASE_URL + '/under_incharge_emp', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	}) // Change URL as needed
      .then((response) => {
		// console.log(response.data);
        const formattedOptions = response.data.map((item) => ({
          value: item.employee_id,
          label: `${item.emp_info} (${item.employee_id})`,
        }));

		// console.log(formattedOptions);
		// alert(formattedOptions);
        setOptions(formattedOptions);
      })
      .catch((error) => console.error("Error fetching options:", error));
  }, []);

  // Handle selection change
  const handleChange = (selected) => {
    setSelectedOptions(selected);
  };

  const [shiftcode,setShiftCodeValue]= useState("");
  const [officeshift,setOfficeShift]= useState([]);

  const handleShift = (event) => {
	const value = event.target.value;
	setShiftCodeValue(value);

	
  };

  const handleShiftCode = async () => {

	axios.get(API_BASE_URL + '/read_shift_info', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})
//    .then(res1 => console.log(res1.data))
	.then(res1 => setOfficeShift(res1.data))
	.catch(err => console.log(err))
   };


   useEffect(() => {
	handleShiftCode();
  }, []);



  const handleAssignShiftSubmit = (e) => {

	e.preventDefault();

	if (isAssigning) {
		return;
	}

    const selectedValues = selectedOptions.map(option => option.value);

	setIsAssigning(true);


	// console.log(user);
	// setError(null);
	// setLoading(true);
	// e.preventDefault();
	axios.post(API_BASE_URL + '/update_assign_shift', {employee_id:selectedValues,shift_code:shiftcode,start_date:user.start_date,end_date:user.end_date}, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	}).then(response => {
		// console.log(response.data);
		// // 	console.log(response.data.message);
		//  })

		var status = response.data.status;

		if (status == 200) {
			toast.success(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",

			});

			const timeout = setTimeout(() => {
				window.location.reload(); // Reload the current page
			}, 5000); // Refresh after 5 seconds

			return () => {
				clearTimeout(timeout); // Cleanup the timeout if the component unmounts
			};

		} else if (status == 401) {
			toast.error(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",

			});
		}
		else if (status == 400) {
			toast.error(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",

			});
		}

		if (status != 200) {
			setIsAssigning(false);
		}


	}).catch(error => {
		// console.log(error);
		// console.log(error.response.data.message);

		setIsAssigning(false);

		toast.error(error?.response?.data?.message || "Failed to assign the shift.", {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",


		});

	});
   };

	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
							<form>
<div className="col-lg-12 col-md-12">
<div className="card" >
<div className="card-header">
	<h3 className="card-title d-flex align-items-center" style={{ color: "#1d3a8a", fontWeight: 600 }}>
		<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
			<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2m-5.146-5.146-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708"/>
		</svg>
		Import Duty Roster
	</h3>
</div>
<div className="card-body">
<div className="row clearfix">

<div className="form-group">
<form onSubmit={handleDutyRosterSubmit}>
<div class="row">
<div className="col-md-12 col-sm-12">


										<div class="row" style={{ display: "flex" }}>
										<button style={{ marginLeft: "auto" }}
											type="button"
											className="btn btn-primary"
											data-toggle="modal"
											data-target="#exampleModal"
											
										>
											Assign Shift
										</button>
									</div>
									
{/* <p ></p> */}
										<div className={docfile ? "form-group" : "form-group required-tooltip"}>


										<p style={{fontSize:'15px',fontFamily:'initial'}}>
The correct column order is (Employee ID, Attendance Date, Shift Code) and you must follow the csv file , otherwise you will get an error while importing the csv file. if you upload the employee who is not under your incharge it will be ignored
</p>

										<label className="form-label">Upload File</label>
										<input type="file" onChange={handleDocumentChange} className={docfile ? "block w-full" : "block w-full required-input"} /><br />
										<span style={{fontSize:'10px',fontWeight:'900'}}>Upload files only: xls, xlsx, csv (allowed file size 500 KB)</span><br />
										{/* <a href={filepath}><span style={{fontSize:'16px',fontWeight:'900',color:'red'}}>{document.document_file}</span></a> */}
										
										</div>
									</div>
									</div>


<button type="submit" className="btn btn-round btn-primary" disabled={isImporting || !docfile}>
{isImporting ? "Importing..." : "Import File"}
</button>
</form>

</div>


</div>

</div>


</div>
</div>

</form>




						</div>
					</div>


					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">
										<div className="card-header">
											<div
												className="card-options"
												style={{ display: "flex", alignItems: "center", gap: "12px" }}
											>
												<EntriesSelector
													entriesPerPage={itemsPerPage}
													setEntriesPerPage={setItemsPerPage}
													setCurrentPage={setCurrentPage}
												/>

												<div style={{ position: "relative", width: "200px" }}>
													<input
														type="text"
														className="form-control form-control-sm"
														placeholder="Search"
														value={searchTerm}
														onChange={(e) => {
															setSearchTerm(e.target.value);
															setCurrentPage(1);
														}}
														style={{
															width: "100%",
															height: "30px",
															fontSize: "13px",
															borderRadius: "4px",
															paddingRight: "28px",
														}}
													/>

													{searchTerm.length > 0 && (
														<span
															onClick={clearInput}
															style={{
																position: "absolute",
																right: "8px",
																top: "50%",
																transform: "translateY(-50%)",
																cursor: "pointer",
																color: "#aaa",
																fontSize: "16px",
																userSelect: "none",
															}}
														>
															✖
														</span>
													)}
												</div>
											</div>
										</div>












										<div className="card-body">
											<div className="table-responsive" style={{ maxHeight: "60vh", overflowY: "auto" }}>
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
														<tr>
															{weekoffColumns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{ cursor: col.sortable ? "pointer" : "default", backgroundColor: "#fff" }}
																>
																	{col.label}
																	{col.sortable && (
																		sortConfig.key === col.key
																			? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																			: " ⇅"
																	)}
																</th>
															))}
														</tr>
													</thead>
													<tbody>



														{
															filteredData.map((flrsft, index) => {

																return <tr key={index}>
																	<td className="d-flex">
																		
																	<span>{flrsft.department_name}</span>
																		
																	

																	</td>
																	<td>
																		<span>{flrsft.emp_info}</span>
																	</td>
																	<td>
																	<span>{flrsft.shift_code}</span>
																	</td>
																	<td>
																		<span>{flrsft.shift_name}</span>
																	</td>
																	<td>
																		<span>{flrsft.shift_date}</span>
																	</td>

																	<td>
																		<span>{flrsft.day}</span>
																	</td>

																	

																	
																</tr>


															})
														}

													</tbody>
												</table>
											</div>



											<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
											/>









										</div>
									</div>
								</div>


							</div>
						</div>
					</div>

				</div>
			</div>




			<div
				className="modal fade"
				id="exampleModal"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<form onSubmit={handleAssignShiftSubmit}>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLabel">
									Assign Shift
								</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="row clearfix">
									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Select Employee</label>
										<Select
											classNames={{
												control: () => "required-select required-tooltip"
											}}
											options={options} isMulti onChange={handleChange} value={selectedOptions} className="form-control p-0" />
			
     
										</div>
									</div>
									<div className="col-md-12 col-sm-12">
										<div className="form-group required-tooltip">
										<label className="form-label">Shift Code</label>
										<select className="form-control show-tick required-input" name="shiftcode" value={shiftcode} onChange={handleShift} >
										<option value="">Select Shift Code</option>
											{officeshift.map(option => (
											<option key={option.shift_code} value={option.shift_code}>
											{option.shift_name}
											</option>
											))}
									</select>
										</div>
									</div>


									<div class="row">
									<div className="col-md-6 col-sm-6">
										<div className="form-group required-tooltip">
										<label className="form-label">From Date</label>
										<DatePicker
											selected={user.start_date ? new Date(user.start_date) : null}
											onChange={(date) => {
												const value = date ? date.toLocaleDateString('en-CA') : "";
												setUser(prev => ({ ...prev, start_date: value }));
											}}
											dateFormat="yyyy-MM-dd"
											placeholderText="Select From Date"
											className="form-control required-input"
											wrapperClassName="w-100"
											maxDate={user.end_date ? new Date(user.end_date) : null}
										/>
										</div>
									</div>


									<div className="col-md-6 col-sm-6">
										<div className="form-group required-tooltip">
										<label className="form-label">To Date</label>
										<DatePicker
											selected={user.end_date ? new Date(user.end_date) : null}
											onChange={(date) => {
												const value = date ? date.toLocaleDateString('en-CA') : "";
												setUser(prev => ({ ...prev, end_date: value }));
											}}
											dateFormat="yyyy-MM-dd"
											placeholderText="Select To Date"
											className="form-control required-input"
											wrapperClassName="w-100"
											minDate={user.start_date ? new Date(user.start_date) : null}
										/>
										</div>
									</div>

									</div>

								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" data-dismiss="modal">
									Close
								</button>
								<button type="submit" className="btn btn-primary" disabled={isAssigning}>
									{isAssigning ? "Saving..." : "Save"}
								</button>
							</div>
						</div>
					</div>

				</form>

			</div>

			
			






		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(ListLeaves);